import React from "react";

function PaginationComponent({ totalPages, currentPage, onPageChange }) {
  const getDisplayedPagenumbers = () => {
    const maxPagesToShow = 3; // Desired number of page numbers to display
    const halfPagesToShow = Math.floor(maxPagesToShow / 2);

    let startPage = Math.max(1, currentPage - halfPagesToShow);
    let endPage = Math.min(totalPages, currentPage + halfPagesToShow);

    // Adjust start and end pages if necessary to show exactly maxPagesToShow
    if (endPage - startPage + 1 < maxPagesToShow) {
      if (startPage === 1) {
        endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);
      } else if (endPage === totalPages) {
        startPage = Math.max(1, endPage - maxPagesToShow + 1);
      }
    }

    const displayedPagenumbers = [];
    for (let i = startPage; i <= endPage; i++) {
      displayedPagenumbers.push(i);
    }

    return displayedPagenumbers;
  };

  const handlePageChange = (pagenumber) => {
    if (pagenumber !== currentPage) {
      onPageChange(pagenumber);
    }
  };

  const previousPage = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const nextPage = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  const goToFirstPage = () => {
    if (currentPage !== 1) {
      onPageChange(1);
    }
  };

  const goToLastPage = () => {
    if (currentPage !== totalPages) {
      onPageChange(totalPages);
    }
  };

  const displayedPagenumbers = getDisplayedPagenumbers();

  return (
    <div className="container">
      <div
        className="flex  flex-wrap mb-2 pagination"
        style={{
          zIndex: "0",
          marginRight: "30px",
          //marginTop: "30px",
          // width:"1262px",
          // display:"flex",
          // justifyContent:"flex-end",
        }}
      >
        <div className="text-right">
          <ul className="flex items-center space-x-2">
            {totalPages > 3 && (
              <li
                className={`page-item ${
                  currentPage === 1
                    ? "pointer-events-none opacity-50"
                    : "cursor-pointer"
                }`}
                onClick={goToFirstPage}
              >
                <a className="block px-2 py-1 border border-gray-300 rounded text-gray-700 hover:bg-gray-100">
                  <b>
                    {/* <i className="mdi mdi-chevron-double-left"></i> */}
                    {/* <i class="fas fa-chevron-double-left"></i> */}
                    <i class="fa-solid fa-angles-left"></i>
                  </b>
                </a>
              </li>
            )}
            <li
              className={`page-item ${
                currentPage === 1
                  ? "pointer-events-none opacity-50"
                  : "cursor-pointer"
              }`}
              onClick={previousPage}
            >
              <a className="block px-2 py-1 border border-gray-300 rounded text-gray-700 hover:bg-gray-100">
                <b>
                  {/* <i className="mdi mdi-chevron-left"></i> */}
                  <i class="fa-solid fa-angles-left"></i>
                </b>
              </a>
            </li>
            {displayedPagenumbers.map((pagenumber) => (
              <li
                key={pagenumber}
                className={`${
                  currentPage === pagenumber
                    ? "bg-blue-500 text-white"
                    : "border border-gray-300 text-gray-700 hover:bg-gray-100"
                } cursor-pointer rounded px-2 py-1`}
                onClick={() => handlePageChange(pagenumber)}
              >
                {/* <a href="#" className="page-link"> */}
                {pagenumber}
                {/* </a> */}
              </li>
            ))}
            <li
              className={`${
                currentPage === totalPages
                  ? "pointer-events-none opacity-50"
                  : "cursor-pointer"
              }`}
              onClick={nextPage}
            >
              <a className="block px-2 py-1 border border-gray-300 rounded text-gray-700 hover:bg-gray-100">
                <b>
                  {/* <i className="mdi mdi-chevron-right"></i> */}
                  <i class="fa-solid fa-angles-right"></i>
                </b>
              </a>
            </li>
            {totalPages > 3 && (
              <li
                className={`${
                  currentPage === totalPages
                    ? "pointer-events-none opacity-50"
                    : "cursor-pointer"
                }`}
                onClick={goToLastPage}
              >
                <a className="block px-2 py-1 border border-gray-300 rounded text-gray-700 hover:bg-gray-100">
                  <b>
                    {/* <i className="mdi mdi-chevron-double-right"></i> */}
                    {/* <i class="fas fa-chevron-double-right"></i> */}
                    <i class="fa-solid fa-angles-right"></i>
                  </b>
                </a>
              </li>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default PaginationComponent;
